export default "__VITE_ASSET__BSlq7t2y__"